@if (client && population) {
<div>
  <div
    id="client-name"
    [routerLink]="['clients', client.id, 'populations']"
    [queryParams]="{ taxYear: taxYr }"
    title="Back to client populations"
  >
    {{ client.name }}
  </div>
  <h2
    (click)="userInfo.isClientAdmin && showPopulationEditModal()"
    id="population-name"
    title="{{ canEditName() ? 'Edit population name' : undefined }}"
    [ngClass]="{ editable: canEditName() }"
  >
    {{ population.name }}
    @if (canEditName()) {
    <div class="edit icon"></div>
    }
  </h2>
  <div id="tax-year">
    <h4>{{ yearLabel }}</h4>
    <h3>{{ population.year }}</h3>
  </div>
  <div class="secondary-sub-menu ui list">
    <div
      [routerLink]="[
        'clients',
        client.id,
        'populations',
        population.id,
        'taxpayers'
      ]"
      [routerLinkActive]="['active']"
      class="item"
    >
      {{ 'all-population-tax-return-alias' | transloco: {taxReturnAlias} }}
    </div>
    <div
      [routerLink]="[
        'clients',
        client.id,
        'populations',
        population.id,
        'notes'
      ]"
      [routerLinkActive]="['active']"
      class="item"
    >
      {{ "notes" | transloco }}
    </div>
  </div>
  @if (showDownloadPackageButton) {
  <div class="population__package">
    @if (generationMessage) {
    <p [innerHtml]="generationMessage"></p>
    } @if (showDownloadPackageButton && packageDate) {
    <p [innerHtml]="packageDate"></p>
    }
    <button
      [disabled]="!showDownloadPackageButton"
      (click)="downloadPackage()"
      class="ui button basic primary "
    >
      {{ "download-package" | transloco }}
    </button>
  </div>
  }
</div>
} @if (userInfo.isClientAdmin) {
<div>
  <div #editPopulationModal id="edit-population-modal" class="ui modal">
    <div class="icon modal-close close"></div>
    <h1>{{ "edit-population-name" | transloco }}</h1>
    <form (ngSubmit)="updatePopulationName()">
      <div class="content">
        <label>{{ "population-name" | transloco }}</label>
        <input
          id="population-name-edit-input"
          type="text"
          name="name"
          [(ngModel)]="editedPopulationName"
        />
      </div>
      <div class="actions">
        <div>
          @if (canDelete()) {
          <div
            (click)="confirmDelete()"
            id="delete"
            title="Delete this population"
          >
            {{ "delete" | transloco }}
          </div>
          } @if (!canDelete()) {
          <div id="no-delete">
            {{
              "you-cannot-delete-a-population-that-has-active-assignees"
                | transloco
            }}
          </div>
          }
        </div>
        <span class="go-back cancel">{{ "cancel" | transloco }}</span>
        <button
          class="ui primary background button"
          [disabled]="!editedPopulationName"
        >
          {{ "save" | transloco }}
        </button>
      </div>
    </form>
  </div>
  <div
    #confirmDeletePopulation
    id="confirm-delete-population"
    class="ui tiny modal"
  >
    <div class="icon modal-close close"></div>
    <h1>{{ "are-you-sure" | transloco }}</h1>
    <div class="content">
      {{ "are-you-sure-you-would-like-to-delete-this-population" | transloco }}
    </div>
    <div class="actions">
      <span class="go-back cancel">{{ "cancel" | transloco }}</span>
      <button class="ui primary background approve button">
        {{ "yes-delete" | transloco }}
      </button>
    </div>
  </div>
</div>
}
